<template>
  <!-- 教育资源 -->
  <div class="page-education">
    <div class="g-banner">
      <div class="qrcode" ref="qrCode1"></div>

      <cmpBanner bannerType="4"></cmpBanner>

      <div class="g-tab-box">
        <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" @eventTabClick="eventTabClick"></cmpTab>
      </div>
    </div>
    <div class="g-content-wrap g-pad-top" :class="{'volun': activeVal == 3}">
      <cmpSubTab ref="cmpSubTab" :tabs="subTabList" :activeVal="activeSubVal" v-if="activeVal === '0' "
        @eventTabClick="eventSubTabClick"></cmpSubTab>

      <div v-if="activeVal === '0' && activeSubVal == 1">
        <div class="qrcode" ref="qrCode"></div>
        <div class="list mt-48">
          <div class="item-inner" v-for="(item, index) in dataList" @click="goDetail(item)" :key="index">
            <div class="item1">
              <div class="pic-box">
                <img v-lazy="item.pictureUrl" alt="">
              </div>
              <div class="info1 flex-col">
                <span class="title">{{item.activityName}}</span>
                <p class="time">{{item.activityTime}}</p>
                <p class="p-wrapper mt-24">{{item.typeName}} <span class="line"></span>
                  {{item.activityAddr}} </p>
              </div>
            </div>

          </div>

          <!-- 无数据 -->
          <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
            <div class="no-data-bg"></div>
            <p class="txt text-center">暂无数据</p>
          </div>
        </div>
      </div>

      <div v-if="activeVal === '0' && activeSubVal == 2" class="list  mt-48">
        <div class="item-inner" style="background: none" v-for="(item, index) in dataList" :key="index"
          @click="goDetail(item)">
          <div class="item1">
            <div class="pic-box">
              <img v-lazy="item.pictureUrl" alt="">
            </div>
            <div class="info1 flex-col">
              <h2 class="title">{{item.activityName}}</h2>
              <p class="time">{{item.activityTime}}</p>
              <p class="p-wrapper mt-24">{{item.typeName}} | {{item.activityAddr}} </p>
            </div>
          </div>

        </div>

        <!-- 无数据 -->
        <div class="g-no-data" v-if="dataList.length === 0 && !listLoading">
          <div class="no-data-bg"></div>
          <p class="txt text-center">暂无数据</p>
        </div>
      </div>

      <div v-if="activeVal === '1'" class="list">
        <div>
          <div class="video-list" v-if="courseList && courseList.length > 0">
            <div class="item-inner" style="background: none" v-for="(item, index) in courseList" :key="index">
              <div class="item1">
                <div class="pic-box">
                  <img v-lazy="item.imgUrl" alt="" />
                  <div class="icon-play" @click="playVideo(item)"></div>
                </div>
                <!-- @click="getDetail(item)" -->
                <div class="info1  flex-col">
                  <h2 class="title">{{ item.title }}</h2>
                  <p class="time">{{ item.createTimeStr | DateFormat('yyyy年MM月dd日') }}</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 无数据 -->
          <div class="g-no-data" v-if="courseList.length === 0 && !listLoading">
            <div class="no-data-bg"></div>
            <p class="txt text-center">暂无数据</p>
          </div>
        </div>
      </div>

      <div v-if="activeVal === '2'" class="child-wrapper">
        <h1 class="m-font-1">儿童体验馆</h1>
        <div class="detail" v-html="childObj.des">
        </div>
        <div class="g-card-list">
          <div class="item g-card-1" style="background: none" v-for="(item, index) in childList" :key="index">
            <div class="pic-box pic1">
              <img v-lazy="item" alt="">
            </div>
          </div>
        </div>

        <div class="notice">
          <div class="date">参观须知</div>
          <p>１、儿童须由成人全程监护陪同参观，并谨慎选择适合自己的参观项目，请家长务必照看好自己的孩子，以免发生走失和意外。</p>
          <p>２、禁止携带食品及饮品进入场馆内。</p>
          <p>３、禁止携带大件物品及背包进入场馆内。</p>
          <p>４、请妥善保管好个人贵重物品。</p>
          <p>５、请爱护场馆内的公共施设及展品，严格按照展品说明及工作人员的指导进行操作，如因违规操作造成展品损坏，需照价赔偿。</p>
          <p>６、禁止在场馆内大声喧哗，请勿拥挤和奔跑。</p>
          <p>７、请自觉维护馆内卫生，请勿随地吐痰、乱扔废弃物等。</p>
          <p>８、如遇突发事件，请按应急标识及工作人员的指挥，从应急通道有序撤离。</p>
        </div>

        <div class="notice agree">
          <div class="date">知情同意</div>
          <p>本人自愿携子女参观体验辽宁省博物馆儿童体验馆，知晓以下信息：</p>
          <p><span class="circle"></span>每名儿童仅限一名家长陪同，不允许儿童在无监护人情况下自行参观。</p>
          <p><span class="circle"></span>家长需看管好自己的孩子，以免发生走失和意外。</p>
          <p><span class="circle"></span>爱护儿童体验馆内的体验设施，如有损坏，需照价赔偿。</p>
          <p><span class="circle"></span>体验馆内不允许携带食品及饮品，做到文明参观。</p>
          <p><span class="circle"></span>监护人同意授权辽宁省博物馆儿童体验馆以博物馆官方形式使用含有本人及儿童肖像的照片或视频。（主要用于官方宣传报道及编辑科普读物等资料使用。）</p>
          <p style="color: #AF844E;margin-top: 55px;">我已阅读以上条款，同意参加本次体验活动。</p>

        </div>
      </div>

      <div v-if="activeVal === '3'" class="volunteer-wrapper">
        <div>
          <div class="intro">
            <div class="left-box">
              <div class="pic-box">
                <img v-lazy="videoPost" alt="" />
                <div class="icon-play" @click="playVideo1()"></div>
              </div>
            </div>
            <div class="right-box">
              <h1>辽博志愿者</h1>
              <div class="content">
                <p><img class="img1" src="../../assets/images/icon_team@2x.png" alt="">团队介绍 - <a
                    @click="getDetail(0)">查看</a></p>
                <p><img src="../../assets/images/icon_rule@2x.png" alt="">辽宁省博物馆志愿者章程 - <a @click="getDetail(1)">查看</a>
                </p>
                <p><img class="img3" src="../../assets/images/icon_behave@2x.png" alt="">辽博志愿者行为规范 - <a
                    @click="getDetail(2)">查看</a></p>
                <p><img class="img4" src="../../assets/images/icon_volun@2x.png" alt="">辽博志愿者报名须知 - <a
                    @click="getDetail(3)">查看</a></p>

              </div>

              <!-- <div class="img-box">
                <img class="img-qrCode" ref="imgQrCode_sign" :src="volunQrCode" alt="">
                <span class="btn m-font-5" @click="mouseenter('sign')">成为志愿者</span>
              </div> -->
            </div>
          </div>
        </div>
        <div class="demeanor">
          <h1>志愿者风采</h1>
          <div class="list ">
            <div class="item mb-20" v-for="(item, index) in demeanorList" @click="goDetail1(item)" :key="index">
              <div class="pic-box">
                <img v-lazy="item.spid" alt="">
                <span class="name">{{ item.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <cmpMyPagination v-if="activeVal == 0 || activeVal == 1" :currentPage="listQuery.currentPage"
        :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>
      <el-dialog :title="title" :visible.sync="detialPlayVideo" @close="closePlay">
        <player1 :video-url="videoUrl" :videoId="videoId"></player1>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import cmpTab from '@cmp/tab'
import player1 from '@cmp/video-player'
import cmpSubTab from '@cmp/tab/sub-tab'

import QRCode from 'qrcodejs2'
import html2canvas from "html2canvas"
export default {
  components: { cmpTab, cmpSubTab, player1 },
  data() {
    return {
      activeVal: '0',
      dataList: [],
      demeanorList: [],
      courseList: [],
      volunteerList: [],
      listQuery: {
        currentPage: 1,
        size: 6,
      },
      childList: [require('../../assets/images/child-bg.png'), require('../../assets/images/child-bg2.png'), require('../../assets/images/child-bg3.png')],
      form: {
        key: '',
        type: '', //	活动类型
        status: '' //	活动状态
      },
      volunteerInfo: {},
      videoPost: "",
      videoUrl: '',
      videoId: '',
      title: '',
      detialPlayVideo: false,
      tabList: [
        {
          name: '社教活动',
          val: '0'
        },
        {
          name: '线上课程',
          val: '1'
        },
        {
          name: '儿童体验馆',
          val: '2'
        },
        {
          name: '辽博志愿者',
          val: '3'
        }
      ],
      volunQrCode: '',
      childObj: {},
      activeSubVal: '1',
      subTabList: [
        {
          name: '活动预告',
          val: '1'
        },
        {
          name: '活动回顾',
          val: '2'
        }
      ],
      total: 0,
      total1: 0,
      listLoading: false,
    }
  },
  watch: {
    $route(to, from) {
      if (to.query.from === 'footer') {
        this.$router.go(0)
      }
    }
  },
  methods: {
    createQrcode(obj) {
      new QRCode(this.$refs.qrCode, {
        text: 'https://wxxcx.lnmuseum.com.cn/socialActivitySign?id=' + obj.id,
        width: 72,
        height: 72,
        colorDark: "#000", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })

      html2canvas(this.$refs.qrCode, {
        backgroundColor: null,
        width: 72,
        height: 72
      }).then(canvas => {
        var imgData = canvas.toDataURL('image/jpeg')  //这里转为图片方式 `[base64转图片并显示](https://blog.csdn.net/weixin_45527702/article/details/117324946)`
        this.$set(obj, 'qrCode', imgData);
      })
    },

    goDetail1(item) {
      this.$router.push({
        path: '/demeanor/detail',
        query: { id: item.id }
      })
    },

    createQrcode1() {
      new QRCode(this.$refs.qrCode1, {
        text: 'https://wxxcx.lnmuseum.com.cn/toBeBsVolunteer?tabIndex=5',
        width: 144,
        height: 144,
        colorDark: "#000", //二维码颜色
        colorLight: "#ffffff", //二维码背景色
        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
      })

      html2canvas(this.$refs.qrCode1, {
        backgroundColor: null,
        width: 144,
        height: 144
      }).then(canvas => {
        var imgData = canvas.toDataURL('image/jpeg')  //这里转为图片方式 `[base64转图片并显示](https://blog.csdn.net/weixin_45527702/article/details/117324946)`
        this.volunQrCode = imgData
      })
    },


    mouseenter(i) {
      if (i == 'sign') {
        if (!this.$refs[`imgQrCode_sign`].style.opacity || this.$refs[`imgQrCode_sign`].style.opacity == '0') {
          this.$refs[`imgQrCode_sign`].style.opacity = '1'
        } else {
          this.$refs[`imgQrCode_sign`].style.opacity = '0'
        }

      } else {
        this.$refs[`imgQrCode_${i}`][0].style.opacity = '1'
      }
    },


    getDataList(val) {
      this.dataList = []

      this.listLoading = true
      this.$http
        .get('../singleMuseum/api/bsActivity/getActivityListForPublic', {
          ...this.listQuery,
          state: val || this.activeSubVal
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            this.dataList = res.result
            this.dataList.map((item, index) => {
              this.$nextTick(() => {
                this.createQrcode(item)
              });
            })
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    getDemeanorList() {
      this.$http
        .get('../singleMuseum/applet/volunteer/groupList', {
          type: 2,
        })
        .then(res => {
          if (res.success) {
            this.demeanorList = res.result
            this.total1 = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },

    getDetail(type) {
      this.$router.push({
        path: '/education/intro/detail',
        query: { type: type }
      })
    },

    playVideo(item) {
      if (item.fileIds) {
        this.detialPlayVideo = true
        this.videoId = item.fileList[0].attId
        this.videoUrl = item.fileList[0].attPath
        this.title = item.fileList[0].attName
      }
    },
    playVideo1() {
      this.detialPlayVideo = true
      this.videoId = this.volunteerInfo.id
      this.videoUrl = this.videoUrl
      this.title = '辽博志愿者宣传'
    },
    closePlay() {
      this.videoUrl = ''
      this.videoId = ''
      this.title = ''
      this.detialPlayVideo = false
    },

    getChildDetail() {
      this.$http1
        .get('/bs/bsVolunteerV2My/detail', {
          type: 5,
        }).then(res => {
          if (res.success) {
            this.childObj = res.result
          }
        })
    },
    getCourseList() {
      this.$http
        .get('../singleMuseum/webapi/course', {
          ...this.listQuery
        })
        .then(res => {
          if (res.success) {
            this.courseList = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    getVolunteerDataList() {
      this.$http
        .get('../singleMuseum/bs/bsVolunteerV2My/detail', { type: 6 })
        .then(res => {
          if (res.success) {
            this.volunteerInfo = res.result
            this.videoUrl = res.result.pic1
            this.videoPost = res.result.pic2

          } else {
            this.$message.error(res.message)
          }
        }).catch(err => {
        })
    },
    handleSearch() {
      this.listQuery.currentPage = 1
      this.getDataList()
    },
    goDetail(item) {
      this.$router.push({
        path: '/education/detail',
        query: { id: item.id }
      })
    },
    eventTabClick(val) {
      this.activeVal = val
      this.listQuery.currentPage = 1
      this.$router.replace({ path: '/education?type=' + val });
      if (this.activeVal === '3') {
        this.getVolunteerDataList()
        this.getDemeanorList()
      } else if (this.activeVal === '2') {
        this.getChildDetail()
      } else if (this.activeVal === '1') {
        this.getCourseList()
      } else {
        this.getDataList()
      }
    },
    eventSubTabClick(val) {
      this.dataList = []
      this.activeSubVal = val
      this.listQuery.currentPage = 1
      this.getDataList(val)
    },
    eventPage(obj) {
      this.listQuery.currentPage = obj.currentPage
      this.listQuery.size = obj.size
      if (this.activeVal === '3') {
        this.getDemeanorList()
        this.getVolunteerDataList()
      } else if (this.activeVal === '2') {
        this.getChildDetail()
      } else if (this.activeVal === '1') {
        this.getCourseList()
      } else {
        this.getDataList()
      }
    },
  },
  created() {
    this.activeVal = this.$route.query.type || '0'
    if (this.activeVal === '3') {
      this.getVolunteerDataList()
      this.getDemeanorList()
    } else if (this.activeVal === '2') {
      this.getChildDetail()
    } else if (this.activeVal === '1') {
      this.getCourseList()
    } else {
      this.getDataList()
    }

    this.$nextTick(() => {
      this.createQrcode1()
    })
  }
}
</script>

<style lang="scss" scoped>
.page-education {
  padding-bottom: 20px;
  /deep/.cmp-sub-tab-wrap {
    .item {
      &:last-child {
        margin-right: 0;
      }
    }
  }

  /deep/ .el-dialog {
    width: 100%;
  }

  .qrcode {
    position: absolute;
    top: -80px;
    left: -80px;
    z-index: -99;
  }

  .volun {
    margin: 0;
    width: 100%;
  }

  .lh-38 {
    line-height: 32px;
  }

  .mt-24 {
    margin-top: 24px;
  }

  .list {
    &.mt-48 {
      margin-top: 48px;
    }
    .item-inner {
      cursor: pointer;
      margin-bottom: 40px;
      .item1 {
        display: flex;
        position: relative;
        flex-direction: column;
        .pic-box {
          width: 100%;
          height: 382px;
          position: relative;
          background: #f6f6f6;
          border-radius: 4px 0px 0px 4px;
          flex-shrink: 0;

          img {
            width: 100%;
            height: 100%;
            transition: all 0.6s;
            object-fit: contain;
          }
        }
        .info1 {
          box-sizing: border-box;
          padding: 31px;
          background: #f6f6f6;
          display: flex;
          justify-content: space-between;
          .title {
            font-family: PF-regular;
            font-size: 32px;
            font-weight: 400;
            color: #000;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            margin-bottom: 30px;
          }

          .time {
            font-family: PF-normal;
            font-size: 26px;
            font-weight: 400;
            color: #ae8148;
          }
          .p-wrapper {
            font-family: PF-normal;
            font-weight: 400;
            color: rgba($color: #010101, $alpha: 0.7);
            line-height: 26px;
            font-size: 26px;
            display: flex;
            align-items: center;
            .line {
              display: inline-block;
              width: 1px;
              height: 26px;
              background: #000000;
              margin: 0 20px;
            }
            &:last-child {
              margin-bottom: 0;
            }
          }

          .des {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-weight: 400;
            color: rgba($color: #000000, $alpha: 0.7);
            .img-box {
              position: relative;
              .img-qrCode {
                opacity: 0;
                position: absolute;
                top: -100%;
                right: 3px;
                transition: all 0.6s;
              }
            }
            .btn {
              flex-shrink: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              // font-size: 16px;
              width: 80px;
              height: 80px;
              margin-left: 55px;
              border-radius: 50%;
              background: #ae8148;
              color: #fff;
              &:hover {
                background: #be9a6d;
              }
            }
          }
        }
      }
    }
  }

  .child-wrapper {
    h1 {
      font-weight: 400;
      color: #000000;
      margin-bottom: 55px;
    }

    .detail {
      /deep/p {
        font-size: 32px;
        text-indent: 64px;
        color: #010101;
        font-weight: 400;
        line-height: 48px;
        margin-bottom: 40px;
        font-family: PF-light;
      }
    }

    .notice {
      background: #f6f6f6;
      margin-top: 60px;
      padding: 40px 0;
      &.agree {
        background: none;
        .circle {
          width: 24px;
          height: 24px;
          margin-right: 20px;
          display: inline-block;
          border-radius: 50%;
          background: #af844e;
        }
      }
      .date {
        font-family: PF-regular;
        font-size: 48px;
        font-weight: 400;
        color: #000000;
        margin-bottom: 55px;
      }
      p {
        font-size: 32px;
        color: #010101;
        font-weight: 400;
        line-height: 48px;
        margin-bottom: 40px;
        font-family: PF-light;
      }
    }
  }

  .volunteer-wrapper {
    .intro {
      display: flex;
      flex-direction: column;
      background: #f6f6f6;
      .left-box {
        position: relative;
        margin-bottom: 55px;
        height: 380px;
        background: #4c767d;
        .pic-box {
          width: 100%;
          height: 100%;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        .name {
          width: 100%;
          height: 56px;
          position: absolute;
          left: 0px;
          bottom: 0px;
          border-radius: 0 0 10px 10px;
          span {
            width: 100%;
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 30px;
            font-weight: bold;
            color: #ffffff;
            padding: 0 30px;
            line-height: 56px;
          }
        }
      }

      .right-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        padding: 0 36px;
        h1 {
          font-family: PF-regular;
          font-size: 38px;
          font-weight: 400;
          padding-bottom: 36px;
          color: #010101;
          background: #f6f6f6;
        }
        .content {
          font-size: 32px;
          font-weight: 400;
          color: #010101;
          line-height: 32px;
          font-family: PF-regular;
          p {
            display: flex;
            align-items: center;
            margin-bottom: 24px;
            a {
              text-decoration: underline;
              text-underline-offset: 8px;
              text-decoration-color: #010101;
            }
            img {
              width: 33px;
              height: 30px;
              margin-right: 23px;
              &.img1 {
                width: 32px;
                height: 35px;
              }
              &.img3 {
                width: 36px;
                height: 36px;
              }
              &.img4 {
                width: 34px;
                height: 35px;
              }
            }
          }
        }
      }

      .img-box {
        width: 100%;
        position: relative;
        .img-qrCode {
          opacity: 0;
          position: absolute;
          top: -100%;
          left: 50%;
          transform: translate(-50%, -50%);
          transition: all 0.6s;
        }
        .btn {
          width: 100%;
          height: 88px;
          flex-shrink: 0;
          letter-spacing: 2px;
          display: inline-block;
          box-sizing: border-box;
          margin: 40px 0 44px;
          background: #ae8148;
          font-size: 32px;
          font-weight: 400;
          color: #f6f6f6;
          line-height: 88px;
          text-align: center;
          &:hover {
            background: #be9a6d;
          }
        }
      }
    }

    .demeanor {
      margin-top: 58px;
      padding: 0 36px;
      h1 {
        font-family: PF-regular;
        font-size: 38px;
        font-weight: 400;
        color: #000000;
        margin-bottom: 42px;
      }

      .item {
        background: #f6f6f6;
      }

      .pic-box {
        position: relative;
        height: 382px;
        img {
          width: 100%;
          height: 100%;
        }
        .name {
          position: absolute;
          display: inline-block;
          box-sizing: border-box;
          bottom: 0;
          left: 0;
          width: 100%;
          font-size: 32px;
          font-weight: 400;
          color: #f6f6f6;
          background: rgba($color: #0f0f0f, $alpha: 0.4);
          z-index: 88;
          height: 53px;
          line-height: 53px;
          padding-left: 26px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .icon-play {
    width: 97px;
    height: 97px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    background: url(~@images/icon-play.png) no-repeat center center;
    background-size: 100% 100%;
  }
}
</style>

